import { Link, ToPathOption } from "@tanstack/react-router";
import { ReactNode } from "react";
import { ArrowLeftIcon } from "components/icons/solid";

export const CardTitle = ({
    actions,
    backLinkTo,
    backLinkTitle,
    children,
}: {
    actions?: ReactNode;
    backLinkTo?: ToPathOption;
    backLinkTitle?: string;
    children: ReactNode;
}) => {
    return (
        <div className="flex flex-col gap-4 pb-4">
            <div className="flex flex-col gap-1">
                {backLinkTo && (
                    <Link
                        to={backLinkTo as "/social"}
                        className="mr-auto flex flex-row items-center gap-2 text-sm font-medium text-slate-400 hover:text-slate-600"
                    >
                        <ArrowLeftIcon className="h-4 w-4" />
                        {backLinkTitle ?? "Back"}
                    </Link>
                )}
                <div className="flex min-h-9 flex-row items-center">
                    <div className="font-sans text-[28px] leading-tight font-semibold text-[#424242]">
                        {children}
                    </div>
                    {actions && <div className="ml-auto">{actions}</div>}
                </div>
            </div>
        </div>
    );
};
